/*
 * @Author: your name
 * @Date: 2021-07-01 09:59:03
 * @LastEditTime: 2021-07-22 11:16:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /WuKong-mobile-web/src/pages/browser/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueXss from 'vue-xss'
import 'normalize.css'
import '@/common/css/var.css'
import '@/common/css/resets.css'
Vue.config.productionTip = process.env.VUE_APP_ENV==='development'? true : false
Vue.config.devtools = process.env.VUE_APP_ENV==='development'? true : false
// 默认白名单参考 xss.whiteList
let options = {
  whiteList: {
    a: ['href', 'style'],
    p: ['style'],
    font: ['color'],
    i:['style'],
    b:['style'],
    u: ['style'],
    span: ['style'],
    img: ['src', 'alt'],
    at: ['uid'],
    blockquote:[],
    hr:[],
    ol:[],
    ul:[],
    li:[],
  },
  stripIgnoreTag: true, // 去掉不在白名单上的标签   true：去掉不在白名单上的标签
  stripIgnoreTagBody: ['script', 'style'] // 去掉不在白名单上的标签及标签体
}

Vue.use(VueXss, options);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
